var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _circle2, _circle3, _circle4, _ellipse3, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMonster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 141,
    viewBox: "0 0 145 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83521 20.3385C7.16161 33.401 12.5407 43.9871 15.5644 47.6474L13.7501 59.5832C6.34044 52.479 2.96024 42.6185 2.19635 38.5763C-2.38704 24.9218 0.66847 8.40278 7.06612 9.6441C12.5965 10.7172 10.6628 16.4872 9.83521 20.3385Z",
    fill: "#7432A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35938 54.4273C10.9635 50.5315 13.5926 47.5205 14.7066 46.502L15.5659 47.5523L13.7517 59.5835C11.9184 57.9793 10.0596 55.4776 9.35938 54.4273Z",
    fill: "#470F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.229 11.8061C116.367 24.4812 112.223 35.609 109.634 39.5885L112.789 51.2416C119.346 43.3431 121.586 33.163 121.887 29.0602C124.893 14.9741 119.984 -1.09197 113.768 0.866713C108.395 2.55988 110.971 8.07352 112.229 11.8061Z",
    fill: "#7432A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.57 45.6203C114.535 41.9315 111.581 39.238 110.359 38.3524L109.624 39.4934L112.791 51.2413C114.431 49.4396 115.994 46.7433 116.57 45.6203Z",
    fill: "#470F6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1198 2.19698C43.9601 -0.0182936 36.5059 13.0505 35.4237 19.8618C36.264 27.0424 28.9625 31.6384 25.2067 33.0389C9.64255 46.2159 13.5575 66.077 16.995 70.6603C19.7449 74.3269 17.5042 77.2169 16.0401 78.2036C-2.90428 95.6202 8.49671 116.207 18.3317 124.323C48.5052 146.705 96.2481 139.633 116.396 133.012C153.062 111.242 146.474 96.9188 134.824 91.2852C123.175 85.6515 116.587 77.3443 116.396 68.9415C116.205 60.5388 116.778 40.2958 100.831 32.084C84.8853 23.8722 92.0468 28.8375 85.1718 16.9973C79.6718 7.52509 69.5121 3.18366 65.1198 2.19698Z",
    fill: "#7432A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0218 19.8618C82.8759 13.9799 77.4969 9.39018 74.9506 7.83058C70.9402 4.56805 66.2614 3.91567 72.659 9.54932C77.777 14.0563 79.152 17.9521 80.6798 21.676C83.0694 27.5006 84.2764 22.2808 84.0218 19.8618Z",
    fill: "#AF6ADC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.475 47.0745C109.711 40.1995 101.563 35.0433 97.5847 33.3245C94.1472 31.5093 88.5135 32.0832 97.1072 36.6665C103.982 40.3332 103.791 44.3054 106.274 48.6022C110.399 56.5467 110.794 50.8939 110.475 47.0745Z",
    fill: "#AF6ADC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.381,
    cy: 56.2415,
    rx: 1.62326,
    ry: 2.0052,
    fill: "#AF6ADC"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.7533,
    cy: 21.2972,
    rx: 1.24131,
    ry: 2.48263,
    transform: "rotate(10.1456 37.7533 21.2972)",
    fill: "#AF6ADC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8091 46.2155C19.4966 39.1877 25.143 34.3752 27.8803 32.8475C31.6042 30.7468 33.323 31.3197 28.2622 35.5211C24.2136 38.8822 22.1193 42.5234 21.5782 43.9238C19.1338 53.7016 18.7136 49.5257 18.8091 46.2155Z",
    fill: "#AF6ADC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.702 42.6831C48.2714 42.454 45.5724 40.0414 44.7767 38.8637C43.2171 37.1131 40.7281 34.7578 43.2489 39.3411C46.3999 45.0703 50.5058 45.3567 53.2749 45.3567C56.1235 45.3567 58.2402 42.9696 52.702 42.6831Z",
    fill: "#AF6ADC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5098 83.2636C16.0376 79.1386 12.982 82.2451 11.2633 84.3139C8.96281 87.083 7.61572 93.5379 8.68516 97.5864C10.022 102.647 12.3136 101.31 11.8362 96.8226C11.3588 92.3347 12.6001 88.4198 14.5098 83.2636Z",
    fill: "#AF6ADC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.55 80.5919C56.3764 83.0363 47.5854 80.8465 44.2115 79.446C40.774 78.0138 35.8279 76.7343 43.5431 83.0745C53.1872 90.9998 63.8216 87.8291 66.2687 86.0346C69.1333 83.9339 74.767 77.5363 64.55 80.5919Z",
    fill: "#470F6B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.952 90.4263C110.514 81.2597 115.537 63.3083 115.728 55.4785C115.728 73.8118 118.592 83.1694 134.825 91.0947C151.058 99.02 143.896 110.956 132.915 123.082C124.131 132.784 105.638 136.737 97.4901 137.501C46.901 148.488 19.2218 128.443 11.6737 117.01C11.6651 116.997 11.6567 116.984 11.6484 116.971C11.6568 116.984 11.6652 116.997 11.6737 117.01C13.9815 120.438 29.7873 124.393 37.4296 125.947C74.0197 133.357 95.1348 116.621 101.119 107.327C113.952 91.5148 100.355 89.4714 91.952 90.4263Z",
    fill: "#470F6B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.628 91.8583C124.225 89.3374 119.706 84.1876 118.496 81.9277C117.796 83.5828 117.579 87.6378 122.316 90.6169C127.052 93.5961 131.737 96.3143 133.487 97.3009C135.333 98.5104 138.949 100.204 138.644 97.3009C138.338 94.3982 134.506 92.463 132.628 91.8583Z",
    fill: "#7432A0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9565,
    cy: 24.2534,
    r: 17.3784,
    fill: "#470F6B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9548,
    cy: 24.2536,
    r: 14.7048,
    fill: "#F5F5F5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.9566,
    cy: 24.2534,
    r: 10.5034,
    fill: "url(#paint0_radial_24980_68086)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5746,
    cy: 24.4438,
    r: 4.96526,
    fill: "#221F38"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8107,
    cy: 59.0108,
    rx: 23.1076,
    ry: 10.6944,
    fill: "url(#paint1_linear_24980_68086)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4209 53.8536C50.1293 53.6245 50.3202 50.2888 50.7022 48.6974C52.6883 48.3918 55.4765 48.22 57.0042 48.3155L57.0042 51.371C57.0042 53.5672 55.2855 54.1401 52.4209 53.8536Z",
    fill: "url(#paint2_linear_24980_68086)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7663 53.7591C57.933 53.6063 57.9839 50.0033 58.2385 48.3164C59.4799 48.3164 62.9492 48.6029 64.5406 48.8893C65.4573 52.0213 63.9677 53.5045 63.1083 53.7591C62.7582 53.8227 61.5996 53.9119 59.7663 53.7591Z",
    fill: "url(#paint3_linear_24980_68086)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_24980_68086",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9566 24.2534) rotate(90) scale(10.5034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#E5B8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901042,
    stopColor: "#18BC29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24980_68086",
    x1: 56.8107,
    y1: 69.7052,
    x2: 56.8107,
    y2: 48.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221F38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#413C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24980_68086",
    x1: 53.7365,
    y1: 48.4109,
    x2: 53.7365,
    y2: 53.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24980_68086",
    x1: 61.469,
    y1: 48.4502,
    x2: 61.469,
    y2: 53.8434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMonster);
export default __webpack_public_path__ + "static/media/aiMonster.e89b2f78f415515d897b7733c95424e6.svg";
export { ForwardRef as ReactComponent };